<div class="chat-email" [class.chat-email--locked]="locked">
  @if (showLabel) {
    <div class="chat-email__label">
      Additional email for {{ passengerName }}
      @if (isMandatory) {
        <span class="chat-email__required" aria-hidden="true">*</span>
      }
    </div>
  }

  @if (locked && chosenSummary === 'Skipped') {
    <div class="chat-email__chosen">{{ chosenSummary }}</div>
  }

  @for (email of emailInputs; track $index) {
    <div class="chat-email__field-row">
      <label class="chat-email__field-wrap">
        <span class="chat-email__field-label">Email address {{ $index + 1 }}</span>
        <input
          type="email"
          [attr.aria-label]="'Email address ' + ($index + 1)"
          [disabled]="locked"
          [(ngModel)]="emailInputs[$index]"
          placeholder="e.g. name@example.com"
        />
        @if (email.trim() && !isValidEmail(email)) {
          <span class="chat-email__error">Enter a valid email address</span>
        }
      </label>
      @if (!locked && emailInputs.length > 1) {
        <button
          type="button"
          class="chat-email__remove"
          [attr.aria-label]="'Remove email address ' + ($index + 1)"
          title="Remove this email address"
          (click)="removeEmailField($index)"
        >
          <fa-icon [icon]="faTrash"></fa-icon>
        </button>
      }
    </div>
  }

  @if (!locked && canAddMore) {
    <button type="button" class="chat-email__add" (click)="addEmailField()">+ New email</button>
  }

  <div class="chat-email__actions">
    @if (!isMandatory) {
      <button type="button" class="chat-email__skip" [disabled]="locked" (click)="onSkip()">
        Skip
      </button>
    }
    <button
      type="button"
      class="chat-email__continue"
      [disabled]="locked || !isValid"
      (click)="onContinue()"
    >
      Continue
    </button>
  </div>
</div>
